<template>
<div class="container">
    <div class="row">
        <Button v-if="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice" class="mb-3" @click="handleBackHomeButton" size="small" type="outline" color="grey">
            <ArrowDropdown :rotate="90" /> Voltar
        </Button>
        <RegisterHeader />
        <BoxRegister @saveChange="saveChanges">
            <div class="col-12 mt-4">
                <h4 class="c-ndarkfour bold">
                    Anexar contrato
                </h4>
                <h6 class="c-ndarkfour regular">
                    Faça o upload do contrato da empresa com a {{ getWhiteLabel | capitalizeFirstLetter }}
                </h6>
            </div>
            <div class="col-12 mt-4">
                <Upload ref="fileUpload" modalForExclude @removeFile="handleDeleteDocument($event, true)" v-if="!blockInputs" :fileSize="10" :limit="100" accept=" .pdf, .jpeg, .png, .doc, .xml" v-model="fileList" multiple @change="handleChange" class="mb-n4">
                </Upload>
                
                <div>
                    <span class="d-flex align-items-center justify-content-between list-upload" v-for="(file, index) in downloadedFileList" :key="index">

                        <div class="d-flex align-items-center">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="20" cy="20" r="20" fill="#F4F7FB" />
                                <path d="M20.667 13.334H16.0003C15.6467 13.334 15.3076 13.4745 15.0575 13.7245C14.8075 13.9746 14.667 14.3137 14.667 14.6673V25.334C14.667 25.6876 14.8075 26.0267 15.0575 26.2768C15.3076 26.5268 15.6467 26.6673 16.0003 26.6673H24.0003C24.3539 26.6673 24.6931 26.5268 24.9431 26.2768C25.1932 26.0267 25.3337 25.6876 25.3337 25.334V18.0007L20.667 13.334Z" stroke="#727D94" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M20.667 13.334V18.0007H25.3337" stroke="#727D94" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p class="c-ndarkfour ml-4 mb-0">
                                {{ file.originalFileName }}
                            </p>
                        </div>
                        <div class="d-flex align-items-center">
                            <!-- EYE -->
                            <Button icon color="grey" type="outline" @click="previewFile(file)" >
                                <Eye class="mr-0" color="#727D94" size="16" />
                            </Button>

                            <!-- DELETE -->
                            <Button class="ml-2" icon color="red" type="outline" @click="handleDeleteDocument(file.id)" v-if="!blockInputs">
                                <Trash color="#E54949" size="16" />
                            </Button>
                        </div>

                    </span>
                </div>
            </div>
            <RegisterNavigationButtons class="my-5" v-if="($store.state.user.userAdm && $store.state.register.company.cnpj.companyType == 2) || USER_TYPE_MIXIN.isBackOffice" :disableNextButton="true" @backStep="backStep" @nextStep="handleNextButton" @saveChange="saveChanges"/>
            <div class="col-12 my-5" v-else>
                <Button @click="saveChanges" :disabled="!fileList.length" :color="getPrimaryColor">
                    Salvar alterações
                </Button>
            </div>
        </BoxRegister>
    </div>
    <CancelRegister :dialogVisible="dialogVisible" @closeModal="handleCloseModal" @cancelRegister="backStep"  @saveChange="saveChanges"/>
    <DocumentDelete :dialogVisible="dialogDeleteVisible" @closeModal="dialogDeleteVisible = false" @confirmDelete="removeFile"/>
    <FullLoading :color="getPrimaryColorHex.five" v-show="$store.state.user.loading" />
</div>
</template>

<script>
import RegisterHeader from '@/components/register/RegisterHeader'
import Trash from '@/components/icons/Trash'
import Eye from '@/components/icons/Eye'
//import CompanyTypeStatus from '@/components/status/CompanyTypeStatus'
import CancelRegister from '@/components/modals/CancelRegister'
import BoxRegister from '@/components/box/BoxRegister'
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import deleteCompanyDocument from '@/api/deleteCompanyDocument'
import DocumentDelete from '@/components/modals/DocumentDelete'
import statusCodesBlockInput from '@/utils/statusCodesBlockInput'
import FullLoading from '@/components/loading/FullLoading'
import getCompanyDocuments from '@/api/getCompanyDocuments'
import insertCompanyDocuments from '@/api/insertCompanyDocuments'
import RegisterNavigationButtons from '@/components/register/RegisterNavigationButtons'

export default {
    components: {
        Trash,
        Eye,
        //CompanyTypeStatus,
        CancelRegister,
        BoxRegister,
        ArrowDropdown,
        DocumentDelete,
        RegisterHeader,
        FullLoading,
        RegisterNavigationButtons,
    },
    data() {
        return {
            dialogDeleteVisible: false,
            dialogCheckVisible: false,
            backToCompanyHome: false,
            dialogRegisterVisible: false,
            dialogRegisterChangeVisible: false,
            dialogVisible:false,
            documents: [],
            fileList: [],
            downloadedFileList: [],
            documentToDeleteId: '',
            documentsChecklist: {},
            documentToDeleteIsLocal: false
        }
    },
    computed: {
        blockInputs() {
            const { isBackOffice, isAdm } = this.USER_TYPE_MIXIN
            const registerComplete = this.$store.state.register.company.cnpj.registerComplete
            return ((!isAdm && !isBackOffice) && statusCodesBlockInput.includes(registerComplete)) ? 'input-block' : ''
        }
    },
    watch: {
        documents() {
            if (!this.$store.state.register.formIsChanged) {
                this.$store.commit('register/setFormIsChanged', true)
            }  
        },
        $route: async function() {
            await this.getDocuments()
            this.$store.commit('register/setFormIsChanged', false)
        }
    },
    methods: {
        handleCloseModal() {
            this.dialogVisible = false
            this.backToCompanyHome = false
        },
        handleBackButton() {
            if (this.$store.state.register.formIsChanged) {
                this.dialogVisible = true
            } else {
                this.backStep()
            }
        },
        handleBackHomeButton() {
            this.backToCompanyHome = true
            if (this.$store.state.register.formIsChanged) {
                this.dialogVisible = true
            } else {
                this.backStep()
            }
        },
        handleDeleteDocument(id, localDocument = false) {
            this.dialogDeleteVisible = true
            this.documentToDeleteId = id
            this.documentToDeleteIsLocal = localDocument
        },
        previewFile(file) {
            window.open(`${process.env.VUE_APP_ROOT_API}/${file.path}`)
        },
        async removeFile() {
            if (this.documentToDeleteIsLocal) {
                this.$refs.fileUpload.removeFile(this.documentToDeleteId);
            } else {
                const result = await deleteCompanyDocument(this.documentToDeleteId)
                if (result.data.ok) {
                    await this.getDocuments()
                } else {
                    this.$notify({
                        title: 'Opa! Encontramos algum erro.',
                        message: '',
                        type: 'error',
                        duration: 3000,
                        offset: 100,
                        showClose: false,
                        customClass: 'error'
                    });
                }
            }
            this.documentToDeleteIsLocal = false
            this.documentToDeleteId = ''
            this.dialogDeleteVisible = false
        },
        toBase64: file => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        }),
        async handleChange(fileList) {
            const base64List = await Promise.all(fileList.map(async file => {
                const base64File = await this.toBase64(file.raw)
                const base64Header = base64File.indexOf(',') + 1
                const fileData = {
                    name: file.name,
                    file: base64File.slice(base64Header , base64File.length)
                }
                return fileData
            }))
            this.documents = base64List
        },
        validateForm() {
            this.$refs['user'].validate((valid) => {
                if (valid) {
                    this.formValid = true
                } else {
                    this.formValid = false
                }
            });
        },
        async saveChanges() {
            let result = true
            if (this.fileList.length) {
                const documentsRequestsResult = await Promise.all(this.documents.map(async file => {
                    return await insertCompanyDocuments({ cnpjId: this.$route.params.idCNPJ, files: file, docType: '0' })
                }))
                result = documentsRequestsResult.every(result => result.ok == true)
            }
            if (result) {
                this.$notify({
                    title: 'Dados salvos com sucesso.',
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                })
                this.$store.commit('register/setFormIsChanged', false)
                if (!this.$store.state.user.userAdm) this.nextStep()
            } else {
                this.$notify({
                    title: 'Opa! Encontramos algum erro.',
                    message: '',
                    type: 'error',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                    customClass: 'error'
                });
            }
        },
        handleNextButton() {
            if (this.$store.state.user.userAdm || this.blockInputs) {
                this.nextStep()
            } else {
                this.dialogCheckVisible = true
            }
        },
        backStep() {
            const { path, params } = this.$route

            const routeType = path.includes('partner') ? 'partner'
                : path.includes('update') ? 'update'
                : 'register'

            const routeCompany = path.includes('pf') ? 'pf'
                : path.includes('pj') ? 'pj'
                : path.includes('procurator') ? 'procurator'
                : path.includes('buyer') ? 'buyer'
                : path.includes('sponsor') ? 'sponsor'
                : path.includes('provider') ? 'provider'
                : 'company'

            const routeStep = path.includes('pf') || path.includes('procurator') ? '0'
                : path.includes('pj') ? '1'
                : path.includes('provider') || path.includes('buyer') ? '3'
                : path.includes('sponsor') || path.includes('company') ? '2'
                : '0' 

            const route = this.backToCompanyHome ? `/company/${this.$route.path.match(/provider|buyer|sponsor/g)||''}`
                : this.USER_TYPE_MIXIN.isBackOffice && routeCompany !== 'buyer'? `/${routeCompany}/${params.idCNPJ}/groups`
                : path.includes('partner') && path.includes('company') ? `/company/register/${params.idCNPJ}/partner/${routeCompany}/${params.id}/${routeStep}`
                : path.includes('partner') && !path.includes('company') ? `/${routeType}/${params.idCNPJ}/${routeCompany}/${params.id}/${routeStep}`
                : `/${routeCompany}/${routeType}/${params.idCNPJ}/${routeStep}`
                
            this.$router.push(route)
        },
        async getDocuments() {
            const result = await getCompanyDocuments(this.$route.params.idCNPJ, '0')
            this.downloadedFileList = result.data.payload
        },
    },
    async created() {
        await this.getDocuments()
        this.$store.commit('register/setFormIsChanged', false)
    }
}
</script>

<style lang="scss" scoped>
.width-650 {
    max-width: 650px;
}
</style>
